/**
 * Pay Event - A collection of payments to be processed via ABA export
 * Replaces and extends the timesheet pay event functionality
 */
export interface IPayEvent {
  _id: string;
  description: string;
  totalAmount: number;
  currency: string;
  appointmentCount: number;
  createdAt: Date;
  updatedAt: Date;

  associationId: string;

  /** Date when payments should be processed */
  payDate: Date;

  /** Date when payment was actually processed (for paid events) */
  paidAt?: Date;

  /** Payment processing information */
  payment?: {
    processedAt?: Date;
    processedBy?: string;
    processorName?: string;
  };

  state: PayEventStatus;
  name: string

  /** State change history */
  stateHistory?: Array<{
    from: string;
    to: string;
    changedBy: string;
    /** @deprecated Use changedBy ID and lookup person details from persons array in API response */
    changedByName?: string;
    changedAt: Date;
    reason?: string;
  }>;

  /** Optional metadata */
  metadata?: {
    createdBy?: string;
    notes?: string;
  };
}

/**
 * Pay event status enumeration
 */
export enum PayEventStatus {
  Draft = "Draft",
  ReadyForExport = "ReadyForExport",
  Exported = "Exported",
  Processed = "Processed",
  Paid = "Paid",
  Cancelled = "Cancelled"
}

/**
 * Pay event creation/update interface
 */
export interface IPayEventUpdate {
  _id?: string;
  description: string;
  payDate: Date;
  associationId: string;
  status?: PayEventStatus;
  metadata?: {
    notes?: string;
  };
}

/**
 * Pay event with appointment details for display
 */
export interface IPayEventWithDetails extends IPayEvent {
  appointments: Array<{
    appointmentId: string;
    personId: string;
    personName: string;
    amount: number;
    description: string;
  }>;
}
